.fast_access {
	display: flex;
	width: 100%;
	padding: 8px 12px 0px 12px;
	gap: 12px;
	align-items: flex-start;

	.text {
		width: 5%;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #4b5563;

		@media screen and (max-width: 750px) {
			display: none;
		}
	}

	.div_main_access {
		width: 90%;
		display: flex;
		gap: 12px;

		@media screen and (max-width: 750px) {
			justify-content: center;
			flex-wrap: nowrap;
		}
	}

	.div_access {
		width: 18%;
		min-width: 160px;

		.access_card {
			display: flex;
			align-items: center;
			justify-content: center;
			gap: 8px;
			padding: 8px 10px;
			border-radius: 10px;
			border: 1px solid #d1d5db;
			background-color: #ffffff;
			color: #374151;
			font-size: 14px;
			font-weight: 500;
			box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
			transition: all 0.2s ease;
			cursor: pointer;

			svg {
				color: #7fb02f;
				transition: color 0.2s ease;
			}

			&:hover {
				background-color: #7fb02f;
				color: white;
				box-shadow: 0 4px 6px rgba(0, 0, 0, 0.08);

				svg {
					color: white;
				}
			}

			.access_card_span {
				@media screen and (max-width: 750px) {
					display: none;
				}
			}
		}

		@media screen and (max-width: 750px) {
			min-width: 40px;

			.access_card {
				padding: 12px 0px;
			}
		}
	}

	.hide_on_mobile {
		@media screen and (max-width: 750px) {
			display: none !important;
		}
	}

	.div_setting {
		width: 5%;
		display: flex;
		justify-content: flex-end;

		&.filter {
			justify-content: flex-start;
		}

		.setting {
			display: flex;
			justify-content: center;
			align-items: center;
			position: relative;
			border: 1px solid #d1d5db;
			border-radius: 10px;
			padding: 6px;
			background-color: #ffffff;
			transition: all 0.2s ease;

			&.active {
				background-color: #7fb02f;
				border: none;

				svg {
					color: white;
				}
			}

			.icon {
				width: 24px;
				height: 24px;
				cursor: pointer;
				color: #7fb02f;
			}

			.settings_options {
				position: absolute;
				top: 42px;
				right: 0;
				width: 22em;
				background-color: #ffffff;
				border-radius: 10px;
				box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.12);
				padding: 16px;
				z-index: 10;

				.settings_title {
					font-size: 15px;
					font-weight: 600;
					color: #374151;
					margin-bottom: 6px;
				}

				.settings_hr {
					border: none;
					border-top: 1px solid #e5e7eb;
					margin: 8px 0;
				}

				.settings_table {
					width: 100%;

					.settings_table_text {
						font-size: 14px;
						padding-left: 8px;
						color: #4b5563;
					}
				}
			}
		}
	}
}
